import Seo from "@common/seo"
import { ContainerFull } from "@common/container"
import { subMenuLayoutParams } from "components/layouts/researchManageLayout"
import ChannelsUnit from "components/channels/channelsUnit"

import StickyHeaderWithCta from "@common/stickyHeaderWithCta"
import PersistanceNotificationBar from "components/persistanceNotificationBar"

Channels.getLayout = subMenuLayoutParams()

export default function Channels() {
  const title = "Channels"
  return (
    <>
      <Seo title={title} />
      <PersistanceNotificationBar />
      <StickyHeaderWithCta title={title} />
      <ContainerFull>
        <ChannelsUnit />
      </ContainerFull>
    </>
  )
}
